// extracted by mini-css-extract-plugin
export default {"container":"chqJh","text":"ohcYh","facebook-container":"XROyE"};